/* Vendor imports */
import React from 'react'
import { Link } from 'gatsby'
import Config from '../../config'
import Utils from '../utils'

/* App imports */
import { Container } from '../style/components/footer'

const Footer = () => (
  <Container>
    <Link to={Utils.resolvePageUrl(Config.pages.tos)}>Terms of Service</Link>
    <Link to={Utils.resolvePageUrl(Config.pages['privacy-policy'])}>
      Privacy Policy
    </Link>
    <Link to={Utils.resolvePageUrl(Config.pages['cookie-policy'])}>
      Cookie Policy
    </Link>
  </Container>
)

export default Footer
